module.exports = __webpack_public_path__ + "719f297b5138f392bf6f2c2e21fea2cd.MP3";